import get from 'get-value';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const sparePartsManagementGroupBatch = (state = {
    isLoadingBatchInfo: false,
    batchRecord: {},
    correlationId: null,
}, action) => {
    switch (action.type) {
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_MANAGEMENT_GROUP_GET: {
            return Object.assign({}, state, { isLoadingBatchInfo: true });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_MANAGEMENT_GROUP_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            const batchRecord = get(action, 'payload.batchRecord', { default: {} });
            return Object.assign({}, state, {
                isLoadingBatchInfo: false,
                batchRecord,
                correlationId,
            });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_MANAGEMENT_GROUP_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, { isLoadingBatchInfo: false });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_MANAGEMENT_GROUP_CREATE: {
            const batchRecord = {
                created: new Date(),
                status: 'NEW'
            };
            return Object.assign({}, state, { batchRecord });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_MANAGEMENT_GROUP_STATUS:
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_MANAGEMENT_GROUP_ERROR: {
            const {correlationId, batchRecord} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, { batchRecord, correlationId });
        }
        default:
            return state;
    }
};
